import { useParams } from 'react-router-dom';
import { useGetModuleWithPermissionsSpecsQuery } from '../../../api/queries/getModuleWithPermissionsSpecs';
import LoadingElement from '../../../components/LoadingElement';
import NotFoundResult from '../../../components/results/NotFoundResult';
import { renderPage } from './modules';

const ModuleDetailsPage = () => {
    const { moduleId } = useParams<{ moduleId: string }>();

    const { data, loading } = useGetModuleWithPermissionsSpecsQuery({
        fetchPolicy: 'cache-and-network',
        variables: { moduleId },
    });

    const module = data?.module;

    if (!module && loading) {
        return <LoadingElement />;
    }

    if (!module) {
        return <NotFoundResult />;
    }

    return renderPage(module);
};

export default ModuleDetailsPage;
